module.exports = __webpack_public_path__ + "img/voice-icon13.59b7f32.png";